import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import ModifyTravelRow from './ModifyTravelRow'
import ViewTravelRow from './ViewTravelRow'
import { TravelMutationDto, TravelOverviewDto } from '../../../config/registrationConfig'
import { Billable } from '../../../config/registration/timeConfig'
import RegistrationList, { registrationListColumns, RegistrationListProps } from '../Registration/RegistrationList'
import * as Yup from 'yup'
import { IColumn } from '@fluentui/react'
import { useTranslation } from 'react-i18next'

export type TravelListProps = RegistrationListProps<TravelOverviewDto>

const getColumns = (translate: (key: string) => string): IColumn[] => [
    registrationListColumns.user(),
    registrationListColumns.date(),
    registrationListColumns.description(translate),
    {
        key: 'distance',
        fieldName: 'distance',
        name: translate('base.table.header.distance'),
        minWidth: 84,
    },
    registrationListColumns.price('rate', translate('base.table.header.rate'), false),
    registrationListColumns.price('subtotal', translate('base.table.header.subtotal'), true),
    registrationListColumns.invoice(translate),
    registrationListColumns.actions(),
]

const getValidationSchema = (translate: (key: string) => string): any =>
    Yup.object().shape({
        userId: Yup.string().trim().required(translate('file.pivot.registration.form.userid.empty')),
        date: Yup.string().trim().required(translate('file.pivot.registration.form.date.empty')),
        description: Yup.string().trim().required(translate('file.pivot.registration.form.description.empty')),
        distance: Yup.string().trim().required(translate('file.pivot.registration.form.distance.empty')),
    })

export default function TravelList(props: TravelListProps): ReactElement {
    const { t: translate } = useTranslation()
    const columns = useMemo(() => getColumns(translate), [])

    return (
        <RegistrationList<TravelOverviewDto, TravelMutationDto>
            detailsListProps={{ columns }}
            {...props}
            baseUrl="/registration/travel"
            initialValues={{ rate: '0.23', distance: '', billable: Billable.Billable }}
            mapItem={(item: TravelOverviewDto) => ({ distance: item.distance, billable: item.billable })}
            viewRow={ViewTravelRow}
            modifyRow={ModifyTravelRow}
            validationSchema={getValidationSchema(translate)}
        />
    )
}
